import { RubricTag } from '@pu/models';

export interface GetTagsRes {
  itemsCount: number;
  tags: RubricTag[];
}
